// extracted by mini-css-extract-plugin
export var acitonButtons = "_ft-0";
export var additionalIcon = "_ft-f";
export var block = "_ft-1";
export var blockContent = "_ft-7";
export var blockDescription = "_ft-8";
export var blockIcon = "_ft-9";
export var blockTitle = "_ft-6";
export var border = "_ft-a";
export var center = "_ft-l";
export var edge = "_ft-b";
export var edgeLabel = "_ft-c";
export var edgePath = "_ft-d";
export var error = "_ft-e";
export var flowchart = "_ft-g";
export var flowchartContent = "_ft-h";
export var highlighted = "_ft-3";
export var hover = "_ft-4";
export var icon = "_ft-i";
export var left = "_ft-m";
export var navButton = "_ft-j";
export var navButtons = "_ft-k";
export var right = "_ft-n";
export var selected = "_ft-2";
export var small = "_ft-5";